// extracted by mini-css-extract-plugin
module.exports = {"wrapperNavigation":"Navigation_wrapperNavigation__1HJb2","navigation":"Navigation_navigation__gpwzf","links":"Navigation_links__1yIKE","active":"Navigation_active__1U_kW"};